export default "__VITE_ASSET__hkMXHE2E__"